import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { formatDate } from 'views/versions/tabs/Constfunctions';

export default function AnswerModel({ openAsnwerPopup, closeAnswerPopup, defaultValue }) {
  return (
    <React.Fragment sx={{ minWidth: '500px' }}>
      <Dialog
        open={openAsnwerPopup}
        onClose={closeAnswerPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={500}
      >
        <DialogTitle id="alert-dialog-title">{defaultValue.Question}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {defaultValue.Answer !== '' ? defaultValue.Answer : 'No answer provided.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>
          {defaultValue.UpdatedBy && defaultValue.Answer !== '' && (
            <Typography className="text-bold" sx={{ paddingRight: '15px' }} fontWeight={500}>
              Answered by: {defaultValue.UpdatedBy}
            </Typography>
          )}
          {defaultValue.Updated && defaultValue.Answer !== '' && (
            <Typography className="text-bold" sx={{ paddingRight: '15px' }} fontWeight={500}>
              Answered On: {formatDate(defaultValue.Updated)}
            </Typography>
          )}
          <Button onClick={closeAnswerPopup} color="secondary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
